
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetogoacabs() {



    const cardData =
    {
        keyword: ' Pune to Goa Cab',
        heading: 'Prince Cabs: Pune to Goa Cab',
        headingDescription: 'Prince Cabs provides comfortable and affordable Pune to Goa Cab services, perfect for beach vacations, family holidays, corporate outings, and long weekend getaways. Our fleet of sedans, SUVs, and luxury cars ensures a safe and enjoyable journey along the scenic Konkan route. With professional chauffeurs, flexible timings, and on-time pickups, we make your Pune to Goa travel hassle-free and convenient. Experience smooth rides, reliable service, and budget-friendly fares with Prince Cabs’ trusted cab service from Pune to Goa.',

        top: 'Top Places to Visit in Goa with Prince Cabs',

   "topPlaces": [
  {
    "title": "Baga Beach",
    "description": "Baga Beach is one of Goa’s most popular beaches, famous for its vibrant nightlife, water sports, and lively beach shacks. Tourists can enjoy parasailing, jet skiing, and banana boat rides during the day. As evening falls, the beach transforms into a party hub with music, dance, and beachside dining. Tito’s Lane, located nearby, is home to some of Goa’s most famous clubs and pubs. The golden sand and bustling energy make it a favorite among both domestic and international travelers. Baga perfectly blends adventure, entertainment, and relaxation."
  },
  {
    "title": "Calangute Beach",
    "description": "Often called the ‘Queen of Beaches,’ Calangute is the largest beach in North Goa, attracting thousands of tourists every year. It offers a perfect mix of adventure sports, shopping, and seaside relaxation. The beach is lined with stalls selling clothes, souvenirs, and handicrafts. Water sports like parasailing and water skiing add to the excitement. During peak season, it is buzzing with tourists, music, and food stalls. Its wide sandy stretch makes it ideal for long walks and sunsets by the sea."
  },
  {
    "title": "Basilica of Bom Jesus",
    "description": "A UNESCO World Heritage Site, the Basilica of Bom Jesus is one of the most important churches in Goa. Built in the late 16th century, it houses the mortal remains of St. Francis Xavier, making it a significant pilgrimage site. The church’s Baroque architecture, intricate carvings, and marble flooring reflect Portuguese influence. The interiors are adorned with gilded altars and paintings depicting scenes from the life of Christ. Tourists and devotees alike visit for its historical and spiritual significance. It stands as a timeless symbol of Goa’s colonial past."
  },
  {
    "title": "Dudhsagar Waterfalls",
    "description": "Dudhsagar Waterfalls, located on the Goa–Karnataka border, is one of India’s tallest waterfalls, cascading from a height of over 1,000 feet. During monsoon, the waterfall resembles a stream of flowing milk, hence the name ‘Dudhsagar’ (Sea of Milk). Surrounded by lush forests, it is a paradise for trekkers and nature lovers. The site is accessible by train, jeep safaris, and trekking trails through the Bhagwan Mahavir Wildlife Sanctuary. Its breathtaking beauty attracts photographers and adventure enthusiasts. It is a must-visit natural wonder when in Goa."
  },
  {
    "title": "Fort Aguada",
    "description": "Fort Aguada is a 17th-century Portuguese fort overlooking the Arabian Sea, built to guard against Dutch and Maratha invasions. The fort features a massive lighthouse, prison cells, and strong fortifications that narrate Goa’s colonial history. Its location provides panoramic views of SinQuerim Beach and the vast ocean. Tourists often explore the fort during sunset for magical views. It is one of the best-preserved forts in Goa and a favorite among history buffs. The site beautifully combines history, architecture, and scenic landscapes."
  },
  {
    "title": "Anjuna Beach",
    "description": "Anjuna Beach is renowned for its hippie culture, flea markets, and vibrant trance parties. The beach gained popularity in the 1960s with backpackers and still retains its bohemian charm. Every Wednesday, the Anjuna Flea Market comes alive with stalls selling jewelry, handicrafts, clothes, and souvenirs. At night, the beach turns into a hub for music festivals and rave parties. Its rocky shoreline adds a unique touch to its beauty. Anjuna is perfect for travelers seeking a mix of culture, shopping, and nightlife."
  },
  {
    "title": "Palolem Beach",
    "description": "Located in South Goa, Palolem Beach is famous for its crescent-shaped shoreline and calm turquoise waters. It is ideal for swimming, dolphin-spotting boat rides, and kayaking. The beach is lined with colorful beach huts offering stays right by the sea. Compared to North Goa, Palolem has a quieter, laid-back vibe, making it perfect for couples and peace seekers. Yoga classes and wellness retreats add to its charm. The breathtaking sunsets here create a truly magical experience for visitors."
  },
  {
    "title": "Chapora Fort",
    "description": "Chapora Fort, made famous by the Bollywood film ‘Dil Chahta Hai,’ is a popular attraction in North Goa. Perched on a hill overlooking Vagator Beach, the fort offers stunning views of the Arabian Sea. Built in 1617 by the Portuguese, it once served as a strategic military base. Today, only the ruins remain, but its charm lies in the picturesque views and historical vibe. The short trek up the hill adds to the adventure. It is a favorite spot for photography and sunset lovers."
  },
  {
    "title": "Spice Plantations",
    "description": "Goa’s spice plantations, located in Ponda, offer a unique experience for visitors to explore the region’s agricultural heritage. Guided tours take visitors through plantations of cardamom, black pepper, nutmeg, cinnamon, and betel nut. Tourists can enjoy traditional Goan meals served on banana leaves as part of the experience. Elephants rides and river bathing were once part of the tour, though now replaced with eco-friendly options. The fragrance and greenery create a refreshing escape from the beaches. It is a must-do for culture and nature lovers."
  },
  {
    "title": "Colva Beach",
    "description": "Colva Beach in South Goa is a serene, 2.4 km stretch of white sand fringed with coconut palms. It is one of the oldest beaches in Goa, popular for its calm waters and scenic sunsets. The beach is less crowded compared to North Goa, offering a peaceful retreat. Tourists can indulge in water sports, enjoy seafood at beach shacks, or simply stroll along the shore. The nearby Our Lady of Mercy Church adds to its cultural significance. Colva offers a blend of relaxation and Goan charm."
  }
],


     "services": [
    {
        "name": "Pune to Goa Cab Innova Crysta",
        "description": "Enjoy a premium travel experience from Pune to Goa in our Innova Crysta cabs, equipped with luxurious interiors, ample legroom, and smooth suspension. Ideal for long journeys, group travel, or family vacations, this vehicle ensures top-notch comfort and safety with experienced chauffeurs at the wheel."
    },
    {
        "name": "Pune to Goa Taxi",
        "description": "Book a reliable and affordable taxi from Pune to Goa with flexible pickup timings and doorstep service. Our taxi service features clean vehicles, trained drivers, and competitive fares, making your long-distance journey smooth and stress-free through scenic routes and highways."
    },
    {
        "name": "Pune to Goa Taxi Service",
        "description": "Professional taxi services from Pune to Goa with 24/7 availability, real-time tracking, and customizable travel plans. Whether it’s a weekend getaway or a business trip, our service ensures timely pickups, clean cars, and courteous drivers to make your journey enjoyable."
    },
    {
        "name": "Pune to Goa Innova Rental",
        "description": "Rent an Innova for your Pune to Goa trip and enjoy unmatched comfort and space. Our Innova rental service is perfect for families, corporate groups, or leisure travelers looking for a spacious vehicle with AC, ample boot space, and a professional driver for a safe and comfortable ride."
    },
    {
        "name": "Pune to Goa Innova Cab Service",
        "description": "Our Innova cab service from Pune to Goa is the perfect solution for comfortable long-distance travel. Whether you're heading to the beach with family or traveling with friends, enjoy smooth roads, reclining seats, and hassle-free service with our experienced drivers."
    },
    {
        "name": "Pune to Goa Cab Package",
        "description": "Explore our Pune to Goa cab packages that include round-trip fare, fuel charges, driver allowance, and tolls. Enjoy transparent pricing and no hidden costs while traveling in comfort with a wide range of vehicle options suitable for all group sizes and budgets."
    },
    {
        "name": "Pune to Goa Dzire Cab",
        "description": "Choose a Swift Dzire cab for your Pune to Goa travel and enjoy an affordable yet comfortable ride. Perfect for couples or small families, our Dzire cabs offer good mileage, clean interiors, and courteous drivers to make your long journey pleasant and cost-effective."
    },
    {
        "name": "Pune to Goa Etios Taxi",
        "description": "Travel in comfort with our Etios taxis from Pune to Goa, known for smooth rides, AC comfort, and economical fares. Ideal for small families or business travelers looking for reliable service, on-time pickup, and well-maintained vehicles for long-distance trips."
    },
    {
        "name": "Pune to Goa Family Tour Cab",
        "description": "Make your family vacation from Pune to Goa memorable with our dedicated family tour cabs. Enjoy spacious seating, luggage-friendly vehicles, and a courteous driver who will assist with sightseeing stops along the way, ensuring a safe and enjoyable road trip for all ages."
    },
    {
        "name": "Pune to Goa Round Trip Cab",
        "description": "Book a round-trip cab from Pune to Goa with flexible return options and guaranteed comfort. Whether you're planning a short vacation or an extended stay, our round-trip service ensures the same cab and driver throughout, giving you peace of mind and excellent value."
    },
    {
        "name": "Pune to Goa Airport Drop Taxi",
        "description": "Need a direct drop to Goa Airport from Pune? Our airport drop taxi service is designed for on-time arrivals with expert drivers who know the best routes. Travel in comfort with AC vehicles and timely service, ideal for both domestic and international flight schedules."
    },
    {
        "name": "Pune to Goa Tempo Traveller",
        "description": "Planning a group tour? Hire our Tempo Traveller from Pune to Goa for a comfortable and spacious journey. Equipped with push-back seats, ample luggage space, and AC, it’s the ideal choice for school trips, corporate tours, or large family vacations."
    },
    {
        "name": "Pune to Goa Luxury Innova",
        "description": "Travel in elegance with our luxury Innova cabs from Pune to Goa. Designed for those who seek comfort and style, these vehicles offer premium interiors, advanced features, and expert chauffeurs, making your journey luxurious from start to finish."
    }
],
"tableData": [
    ["Pune to Goa Cab Innova Crysta", "Pune to Goa Taxi"],
    ["Pune to Goa Taxi Service", "Pune to Goa Innova Rental"],
    ["Pune to Goa Innova Cab Service", "Pune to Goa Cab Package"],
    ["Pune to Goa Dzire Cab", "Pune to Goa Etios Taxi"],
    ["Pune to Goa Family Tour Cab", "Pune to Goa Round Trip Cab"],
    ["Pune to Goa Airport Drop Taxi", "Pune to Goa Tempo Traveller"],
    ["Pune to Goa Luxury Innova", ""]
],


    "whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Goa Cab Service",
        "WhyChoosedescription": "Prince Cabs offers trustworthy and convenient cab service from Pune to Goa, perfect for vacations, road trips, or business travel. Enjoy a hassle-free journey with on-time pickups and professional service."
    },
    {
        "WhyChooseheading": "Comfortable and Long-Distance Ready Vehicles",
        "WhyChoosedescription": "Our cabs are equipped with spacious interiors, air-conditioning, and comfortable seating to ensure a relaxing drive over the long Pune to Goa route. Ideal for solo travelers, families, and groups."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Long Highway Routes",
        "WhyChoosedescription": "Our drivers are skilled in handling long-distance travel and are well-versed with the Pune to Goa route. They ensure safe driving, smooth navigation, and planned halts for a pleasant road trip experience."
    },
    {
        "WhyChooseheading": "Flexible Booking and Trip Options",
        "WhyChoosedescription": "Whether you need a one-way cab, round trip, or multi-day Goa stay, Prince Cabs offers flexible packages tailored to your travel plans. Easy booking via call, website, or WhatsApp."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Fleet",
        "WhyChoosedescription": "We follow strict hygiene protocols. Each cab is cleaned and sanitized before every trip. Our vehicles are regularly serviced and checked to ensure safety and reliability throughout the journey."
    },
    {
        "WhyChooseheading": "Transparent Pricing Without Hidden Costs",
        "WhyChoosedescription": "Our Pune to Goa cab fares are competitive and clearly shared upfront. No hidden charges—just honest pricing with multiple secure payment options including UPI, cards, and cash."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Seamless Travel",
        "WhyChoosedescription": "Our dedicated support team is available around the clock to assist you before, during, and after your trip. From booking help to travel updates, we ensure a smooth and stress-free Pune to Goa cab experience."
    }
]



















    }

   const faqData = [
    {
        question: 'Does Prince Cabs provide Pune to Goa cab services?',
        answer: 'Yes, Prince Cabs offers dependable and comfortable Pune to Goa cab services, perfect for vacations, weekend getaways, and group travel.',
    },
    {
        question: 'What cab options are available for Pune to Goa?',
        answer: 'We offer multiple cab choices such as hatchbacks, sedans, SUVs, and tempo travellers to suit different group sizes and travel preferences.',
    },
    {
        question: 'Are the cabs suitable for long-distance travel like Pune to Goa?',
        answer: 'Absolutely! Our cabs are equipped with air conditioning, spacious seating, entertainment options, and professional drivers for a safe and relaxing journey.',
    },
    {
        question: 'Can I customize the route or plan sightseeing stops during the Pune to Goa trip?',
        answer: 'Yes, you can personalize your itinerary with custom pickup points, drop-offs, and scenic stops along the way. We aim to make your travel enjoyable and flexible.',
    },
    {
        question: 'What is the cost of a cab from Pune to Goa?',
        answer: 'Pricing depends on the type of cab, distance, travel duration, and any custom requests. Contact Prince Cabs for a competitive and customized quote.',
    },
    {
        question: 'How can I book a Pune to Goa cab with Prince Cabs?',
        answer: 'You can book easily by contacting us via our website or phone with your travel dates and preferences. Our team will guide you through the process.',
    },
    {
        question: 'Are Prince Cabs vehicles sanitized and well-maintained for long trips?',
        answer: 'Yes, all our vehicles undergo regular maintenance and are thoroughly cleaned and sanitized to ensure safety, comfort, and hygiene throughout your journey.',
    },
];

const testimonials = [
    {
        name: "Mr. Nikhil Kamat",
        position: "Goa Trip Planner",
        text: "We booked a Pune to Goa cab with Prince Cabs. The ride was smooth, the driver was cooperative, and we had a great experience overall.",
        image: "/img/testimonial/testimonial-thumb-goa-1.png",
    },
    {
        name: "Ms. Shraddha More",
        position: "Travel Enthusiast",
        text: "Prince Cabs made our Pune to Goa road trip unforgettable. The cab was comfortable and the service was top-notch from start to finish.",
        image: "/img/testimonial/testimonial-thumb-goa-2.png",
    },
];
























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Goa Cab",
  "image": "https://princecab.com/assets/images/pune-goa-cab.jpg",
  "description": "Book Pune to Goa cab with Prince Cabs – Comfortable and affordable taxi options including Innova Crysta, Dzire, Etios, and Tempo Traveller. Ideal for family tours, airport drops, and round trip bookings. 24/7 online service.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "7380"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7500",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-goa-cab"
  }
};



    return (
        <div>
<Helmet>
  <title>Pune to Goa Cab | Long Distance Taxi & Tour Packages | Prince Cabs</title>
  <meta
    name="description"
    content="Prince Cabs offers Pune to Goa cab service with reliable vehicles like Innova Crysta, Etios, Dzire, and Tempo Traveller. Perfect for family tours, group trips, and airport transfers. Book 24/7 online."
  />
  <meta
    name="keywords"
    content="Pune to Goa Cab Innova Crysta, Pune to Goa Taxi, Pune to Goa Taxi Service, Pune to Goa Innova Rental, Pune to Goa Innova Cab Service, Pune to Goa Cab Package, Pune to Goa Dzire Cab, Pune to Goa Etios Taxi, Pune to Goa Family Tour Cab, Pune to Goa Round Trip Cab, Pune to Goa Airport Drop Taxi, Pune to Goa Tempo Traveller, Pune to Goa Luxury Innova"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/3.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetogoacabs;